import React, { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import IncomingCallPopup from "./IncomingCallPopup";
import { BrowserPhoneState } from "./telephonyTypes";
import { useBrowserPhoneContext } from "./BrowserPhoneProvider";
import useCallCenterT from "../../../hooks/useCallCenterT";
import { runTelephonyAction } from "./placeBrowserCall";
import { toast } from "react-toastify";

const IncomingCallOverlay = () => {
  const t = useCallCenterT();
  const { store, actions } = useBrowserPhoneContext();
  const [accepting, setAccepting] = useState(false);
  const isIncoming =
    store.state === BrowserPhoneState.INCOMING_CALL ||
    store.state === BrowserPhoneState.INCOMING_CONNECTING;

  const handleAccept = useCallback(async () => {
    if (accepting) return;
    setAccepting(true);
    try {
      await runTelephonyAction({ action: actions.acceptCall, toast, t, providerName: store.config?.providerName });
    } finally {
      setAccepting(false);
    }
  }, [accepting, actions, t]);

  const handleReject = useCallback(async () => {
    if (accepting) return;
    await runTelephonyAction({ action: actions.rejectCall, toast, t, providerName: store.config?.providerName });
  }, [accepting, actions, t]);

  if (!isIncoming || typeof document === "undefined") {
    return null;
  }

  const caller =
    store.activeCall?.phoneNumber ||
    store.activeCall?.remoteIdentity?.uri?.user ||
    t("ccUnknownCaller");

  const connecting = accepting || store.state === BrowserPhoneState.INCOMING_CONNECTING;

  return createPortal(
    <div
      className="fixed inset-0 z-[99999999] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-[2px]"
      role="alertdialog"
      aria-modal="true"
      aria-label={t("ccGlobalDialerIncoming")}
    >
      <div className="w-full max-w-sm rounded-2xl border border-emerald-300 bg-white p-4 shadow-2xl ring-4 ring-emerald-400/40">
        <IncomingCallPopup
          visible
          caller={caller}
          accountNo={store.activeCall?.accountNo}
          onAccept={handleAccept}
          onReject={handleReject}
          disabled={connecting}
          connecting={connecting}
          t={t}
        />
      </div>
    </div>,
    document.body
  );
};

export default IncomingCallOverlay;
